import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";
import { ranking } from "@/mocks/siteData";
import FailCard from "@/components/feature/FailCard";
import SectionHeading from "@/components/feature/SectionHeading";
import Reveal from "@/components/base/Reveal";

export default function FeaturedSection() {
  const [lead, ...rest] = articles;

  return (
    <section className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-50">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-10">
        <div className="lg:col-span-2">
          <SectionHeading
            eyebrow="Latest Breakdown"
            title="最新翻车事件复盘"
            desc="按分钟还原经过，标出关键节点与可核实的画面，让你在最短时间内看懂发生了什么。"
            action={
              <Link
                to="/category"
                className="inline-flex items-center gap-1.5 h-10 px-4 rounded-md border border-background-300 text-sm text-foreground-800 whitespace-nowrap hover:border-primary-400 hover:text-primary-600 transition-colors"
              >
                查看全部事件
                <i className="ri-arrow-right-line"></i>
              </Link>
            }
          />

          <Reveal>
            <FailCard {...lead} variant="wide" />
          </Reveal>

          <div className="mt-6 bg-background-50 border border-background-200 rounded-lg px-4 md:px-5">
            {rest.slice(0, 4).map((item, index) => (
              <Reveal key={item.id} delay={index * 60}>
                <FailCard {...item} variant="minimal" />
              </Reveal>
            ))}
          </div>
        </div>

        <aside className="lg:col-span-1">
          <div className="lg:sticky lg:top-32">
            <div className="rounded-lg bg-background-100 border border-background-200 overflow-hidden">
              <div className="flex items-center justify-between gap-3 px-5 py-4 bg-foreground-950">
                <h2 className="font-heading font-bold text-base text-background-50 flex items-center gap-2">
                  <i className="ri-fire-line text-primary-400"></i>
                  翻车指数榜
                </h2>
                <span className="text-[11px] text-background-300">近 30 天</span>
              </div>
              <ol className="p-2">
                {ranking.map((item) => (
                  <li key={item.id}>
                    <Link
                      to={`/article/${item.id}`}
                      className="group flex items-start gap-3 p-3 rounded-md hover:bg-background-50 transition-colors"
                    >
                      <span
                        className={`shrink-0 w-6 h-6 rounded-md text-xs font-bold flex items-center justify-center ${
                          item.rank <= 3
                            ? "bg-primary-500 text-background-50"
                            : "bg-background-300 text-foreground-700"
                        }`}
                      >
                        {item.rank}
                      </span>
                      <span className="flex-1 min-w-0">
                        <span className="block text-sm text-foreground-900 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
                          {item.title}
                        </span>
                        <span className="mt-1.5 flex items-center gap-2 text-[11px] text-foreground-500">
                          <span className="px-1.5 py-0.5 rounded bg-accent-100 text-accent-900">{item.tag}</span>
                          <span className="flex items-center gap-1">
                            <i className="ri-flashlight-line text-primary-500"></i>
                            {item.score}
                          </span>
                        </span>
                      </span>
                    </Link>
                  </li>
                ))}
              </ol>
            </div>

            <div className="mt-4 rounded-lg p-5 bg-secondary-100 border border-secondary-200">
              <h3 className="font-heading font-semibold text-sm text-secondary-950 flex items-center gap-2">
                <i className="ri-information-line"></i>
                内容说明
              </h3>
              <p className="mt-2 text-xs leading-relaxed text-secondary-900/85">
                站内所有图片均为契合内容的示意画面，不包含当事人真实影像。翻车指数依据传播量、信息完整度与流程问题严重程度综合评定。
              </p>
            </div>
          </div>
        </aside>
      </div>
    </section>
  );
}